import {Api} from "tools/api";
import {ApiRequest} from "framework/api";
import {GridSelection} from "controls/grid/gridSelection";
import {MetricInfo} from "framework/entities/metricInfo";
import {
	convertMetricConfigurationsToPayload
} from "areas/metrics/components/MetricSelector/utils/convertMetricConfigurationToPayload";

export class ManagementApi {
	static getAgentUrl(accountId: string, id: string) {
		return Api.accountRoot(accountId) + `agents/${id}/details`;
	}

	static getQualifiersLastValue(data: object) {
		return Api.fetchPost(`${Api.serverRoot()}metrics/registeredMetrics/lastinfo`, data)
	}

	static getSearchUrl() {
		return Api.accountRoot() + 'agents/lite?name=';
	}
}

export type MetricPayload = {
	metricId: string
	conversion?: string
	customUnit?: string
	conversionUnit?: string
}

export function getMetricLatestValue(metrics: MetricPayload[]){
	return new ApiRequest<MetricInfo[]>({
		url: 'metrics/registeredMetrics/lastinfo',
		method: 'POST',
		payload: convertMetricConfigurationsToPayload(metrics)
	})
}


export function deleteDataRegistry<T>(selection: GridSelection<T>) {
	const url = `dataRegistry/delete`;
	return selection.store.getSelectionApiRequest({url: url, payload: {}, selection: selection});
}

export function setManagementElementInMaintenance(type: string, maintenanceData: object){
	const multipleSavePaths: {[id:string]: string} = {agent: 'multipleAgents', service: 'multipleServices', asset: 'multipleAssets'};
	return new ApiRequest<MetricInfo[]>({
		url: 'maintenance/' + multipleSavePaths[type],
		method: 'POST',
		payload: maintenanceData
	})
}
